import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';

@Component({
  selector: 'app-change-offer-to-base-prepaid',
  standalone: false,
  templateUrl: './change-offer-to-base-prepaid.component.html',
  styleUrl: './change-offer-to-base-prepaid.component.css',
})
export class ChangeOfferToBasePrepaidComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  ngOnInit() {
  }

  constructor(
      private store: Store<any>
  ) {}

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  save() {
    this.store.dispatch(
        new SaveMission(
            {
              phoneNumber: this.line.phoneNumber,
              currentOfferId: this.line.offer.id,
              currentOfferLabel: this.line.offer.labelTunnel,
            },
            this.procedureCode
        )
    );
  }
}
